import { unwrapResult } from '@reduxjs/toolkit'
import { Modal, Spin, Image } from 'antd'
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { getKQBLQMCode } from '../../treatment/oralCases/oralCasesSlice'
import {
  getCloseTreatmentBeautySignQRCodeAsync,
  getTreatmentBeautySignImgAsync,
} from '../../treatment/beautyClinic/beautyClinicSlice'

let timer: any = null

interface ScanSignatureModalProps {
  visible: boolean
  onCancel: () => void
  /** 轮询到签名图后回调（签名图已由微信端存储，直接走保存） */
  onSubmit: (signImg: any) => void
}

export const ScanSignatureModal = ({
  visible,
  onCancel,
  onSubmit,
}: ScanSignatureModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [wxCode, setWxCode] = useState('') //二维码
  const [key, setKey] = useState('') //二维码key
  const [loading, setLoading] = useState(false) //二维码加载中

  // 个人设置扫码签名二维码（关联 grsz 业务）
  const getScanCode = () => {
    setLoading(true)
    dispatch(getKQBLQMCode({ pageParam: 'grsz' }))
      .then(unwrapResult)
      .then((res: any) => {
        setWxCode(res?.url)
        setKey(res?.key)
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (visible) {
      setWxCode('')
      setKey('')
      getScanCode()
    } else {
      // 关闭时通知后端关闭签名二维码
      if (key) {
        dispatch(getCloseTreatmentBeautySignQRCodeAsync())
          .then(unwrapResult)
          .catch(() => {
            // do nothing.
          })
      }
      setWxCode('')
      setKey('')
    }
  }, [visible])

  // 轮询获取签名，拿到后直接回调保存并停止轮询
  useEffect(() => {
    if (visible) {
      timer = setInterval(() => {
        if (key) {
          dispatch(getTreatmentBeautySignImgAsync(key))
            .then(unwrapResult)
            .then((res: any) => {
              // 空值（null/''/{}）均视为未签名，继续轮询
              if (res && JSON.stringify(res) != '{}') {
                timer && clearInterval(timer)
                onSubmit(res)
              }
            })
        }
      }, 2000)
    }

    return () => {
      timer && clearInterval(timer)
    }
  }, [visible, key])

  return (
    <Modal
      width={380}
      title='扫码签名'
      visible={visible}
      maskClosable={false}
      footer={null}
      onCancel={onCancel}
    >
      <div style={{ textAlign: 'center', padding: '10px 0' }}>
        <p style={{ marginBottom: 16 }}>使用微信扫描二维码进行签名</p>
        <Spin spinning={loading}>
          {wxCode != '' ? (
            <Image
              width={220}
              src={wxCode}
              onError={() => setWxCode('')}
            />
          ) : (
            <p
              style={{
                fontWeight: 'bold',
                fontSize: '16px',
                cursor: 'pointer',
              }}
              onClick={() => {
                getScanCode()
              }}
            >
              图片加载失败点击刷新页面
            </p>
          )}
        </Spin>
      </div>
    </Modal>
  )
}
